import { CSSProperties, FC } from "react";
import { Col, Row, Space } from "antd";
import { formatNumber } from "../../../../common/Number";
import { VendorCountResponse } from "../../../../types/VendorTypes";
import classes from "./Metrics.module.less";

interface MetricsProps extends Partial<VendorCountResponse> {
    vendors?: number;
    style?: CSSProperties;
}
export const Metrics: FC<MetricsProps> = ({
    spend = 0,
    vendors = 0,
    contracts = 0,
    savings = 0,
    style,
}) => {
    const data = [
        {
            label: "Number of vendors",
            value: vendors,
        },
        {
            label: "Number of contracts",
            value: contracts,
        },
        {
            label: "Total spend",
            value: formatNumber(spend),
        },
        {
            label: "Total est. savings",
            value: formatNumber(savings),
        },
    ];
    return (
        <Row className={classes.container} justify="space-between" style={style}>
            {data.map((item) => (
                <Col span={4} key={item.label}>
                    <Space direction="vertical" size={8} align="center" className={classes.metric}>
                        <div className={classes.label}>{item.label}</div>
                        <div className={classes.value}>{item.value}</div>
                    </Space>
                </Col>
            ))}
        </Row>
    );
};
